import { saveAs } from 'file-saver';

export const downloadCSV = <T extends Record<string, any>>(
    content: Array<T>,
    filename: string,
    createHeader = true,
) => {
    const csvString = createCSVString<T>(content, createHeader);
    const blob = new Blob(['sep=,\n', csvString], {
        type: 'text/csv;charset=utf-8',
    });
    saveAs(blob, filename);
};

function createCSVString<T extends Record<string, any>>(
    content: Array<T>,
    createHeader = true,
): string {
    if (content.length > 0) {
        const header = Object.keys(content[0]).join(',');
        return content
            .map((c) => Object.values(c).map(escapeStrings).join(','))
            .reduce((csv, row) => csv + '\n' + row, createHeader ? header : '');
    }

    return '';
}

const escapeStrings = (value: any) =>
    typeof value === 'string' ? `"${value}"` : value;
